const maxHeight = 300

const getChartOptions = (darkTheme = false, width) => {
  return {
    timeScale: {
      timeVisible: true,
      secondsVisible: false,
      borderVisible: false,
    },
    width: width,
    height: maxHeight,
    rightPriceScale: {
      scaleMargins: {
        top: 0.3,
        bottom: 0.25,
      },
      borderVisible: false,
    },
    layout: {
      backgroundColor: darkTheme ? '#131722' : '#FFFFFF',
      textColor: darkTheme ? '#d1d4dc' : '#191919',
    },
    grid: {
      vertLines: {
        color: darkTheme ? 'rgba(42, 46, 57, 0.6)' : 'rgba(42, 46, 57, 0.3)',
      },
      horzLines: {
        color: darkTheme ? 'rgba(42, 46, 57, 0.6)' : 'rgba(42, 46, 57, 0.3)',
      },
    },
    crosshair: {
      vertLine: {
        labelVisible: false,
      },
    },
    localization: {
      locale: 'ru-RU',
    },
  }
}

export default getChartOptions
